import React from 'react';
import { Button } from '@mui/material';

export default function ButtonCeci({sx, onClick, children}) {
  return (
    <Button
      onClick={onClick}
      variant="contained"
      sx={{
        borderRadius: '46px',
        border: '2px solid #527180',
        backgroundColor: '#527180',
        color: '#FFF',
        textTransform: 'none',
        fontSize: '1.4rem',
        fontFamily: 'Barlow, sans-serif',
        fontWeight: 400,
        paddingX: '1.5rem',
        paddingY: '0.3rem',
        transition: 'all 0.25s ease',
        '&:hover': {
          borderRadius: '40px',
          border: '2px solid #527180',
          backgroundColor: '#FFF',
          color: '#527180',
        },
        ...sx
      }}
    >
      {children}
    </Button>
  );
}
